import React, { useRef, useState } from "react";
import { Upload, X, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { imgUrl } from "../../lib/api";

// Single image uploader
export function ImageUpload({ value, onChange, label = "Εικόνα", testid = "image-upload" }) {
  const ref = useRef();
  const [uploading, setUploading] = useState(false);

  const upload = async (file) => {
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.path);
    } catch {
      toast.error("Αποτυχία μεταφόρτωσης");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div>
      {label && <label className="block text-sm font-medium text-[#1E3A2F] mb-2">{label}</label>}
      <div className="flex items-center gap-3">
        {value ? (
          <div className="relative h-24 w-24 rounded-sm overflow-hidden border border-[#E5E9E4]">
            <img src={imgUrl(value)} alt="" className="h-full w-full object-cover" />
            <button type="button" onClick={() => onChange("")} className="absolute top-1 right-1 bg-black/60 text-white rounded-full p-0.5"><X className="h-3 w-3" /></button>
          </div>
        ) : (
          <button type="button" onClick={() => ref.current.click()} data-testid={testid} className="h-24 w-24 rounded-sm border-2 border-dashed border-[#E5E9E4] flex flex-col items-center justify-center text-[#536D61] hover:border-[#1E3A2F] hover:text-[#1E3A2F]">
            {uploading ? <Loader2 className="h-5 w-5 animate-spin" /> : <><Upload className="h-5 w-5" /><span className="text-xs mt-1">Ανέβασμα</span></>}
          </button>
        )}
        {value && (
          <button type="button" onClick={() => ref.current.click()} className="text-sm text-[#1E3A2F] underline">Αλλαγή</button>
        )}
      </div>
      <input ref={ref} type="file" accept="image/*" className="hidden" onChange={(e) => upload(e.target.files[0])} />
    </div>
  );
}

// Multiple images uploader
export function MultiImageUpload({ values = [], onChange, testid = "multi-image-upload" }) {
  const ref = useRef();
  const [uploading, setUploading] = useState(false);

  const upload = async (files) => {
    if (!files?.length) return;
    setUploading(true);
    try {
      const uploaded = [];
      for (const file of files) {
        const fd = new FormData();
        fd.append("file", file);
        const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
        uploaded.push(data.path);
      }
      onChange([...values, ...uploaded]);
    } catch {
      toast.error("Αποτυχία μεταφόρτωσης");
    } finally {
      setUploading(false);
    }
  };

  const remove = (i) => onChange(values.filter((_, idx) => idx !== i));

  return (
    <div>
      <label className="block text-sm font-medium text-[#1E3A2F] mb-2">Εικόνες προϊόντος</label>
      <div className="flex flex-wrap gap-3">
        {values.map((v, i) => (
          <div key={i} className="relative h-24 w-24 rounded-sm overflow-hidden border border-[#E5E9E4]">
            <img src={imgUrl(v)} alt="" className="h-full w-full object-cover" />
            <button type="button" onClick={() => remove(i)} className="absolute top-1 right-1 bg-black/60 text-white rounded-full p-0.5"><X className="h-3 w-3" /></button>
          </div>
        ))}
        <button type="button" onClick={() => ref.current.click()} data-testid={testid} className="h-24 w-24 rounded-sm border-2 border-dashed border-[#E5E9E4] flex flex-col items-center justify-center text-[#536D61] hover:border-[#1E3A2F] hover:text-[#1E3A2F]">
          {uploading ? <Loader2 className="h-5 w-5 animate-spin" /> : <><Upload className="h-5 w-5" /><span className="text-xs mt-1">Προσθήκη</span></>}
        </button>
      </div>
      <input ref={ref} type="file" accept="image/*" multiple className="hidden" onChange={(e) => upload(Array.from(e.target.files))} />
    </div>
  );
}
